import { Col, Row, Table, Input } from "reactstrap"
import { useEffect, useState } from "react";
import { AddNotice, ConfirmationModal, InfoModal, LoadingModal } from "./BaseModal";
import { getContacts } from "../api/api";
import Spinner from "./Spinner";
import DatePicker from "react-datepicker";
import Dropdown from "./dropdown";
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { ja } from "date-fns/locale";

const NoticeSetting = () => {


    const [modal, setModal] = useState(false);
    const [notice, setNotice] = useState();
    const [newNotice, setNewNotice] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const authToken = localStorage.getItem('accessToken');
    const groupId = localStorage.getItem('username');
    const [msg, setMsg] = useState();
    const [loading, setLoading] = useState(false);
    const [noticeTitle, setNoticeTitle] = useState('');
    const [confirm, setConfirm] = useState(false);
    const [title, setTitle] = useState({ title: "", message: "", button: "", task: "" })
    const [openCalendar, setOpenCalendar] = useState(false);
    const [date, setDate] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
    const [time, setTime] = useState(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm:ss'));
    const [timeFocus, setTimeFocus] = useState(false);
    const [selectValue, setSelectValue] = useState([]);
    const [noticeDesc, setNoticeDesc] = useState('');
    const [updateType, setUpdateType] = useState();
    const [apiStatus, setApiStatus] = useState(false);
    const toggleModal = () => {
        setModal(!modal);
        handleInput();
    }
    const toggleNewNotice = () => {
        if (selectValue.length > 0 && noticeTitle !== "" && noticeDesc !== "") {
            setNewNotice(!newNotice);
            setModal(!modal);
            setMsg();
            if (title && title.task === 'add') {
                setTitle({
                    title: "追加内容はこれでよろしいですか？",
                    message: "追加内容はこれでよろしいですか？",
                    button: "追加",
                    task: "addConfirm"
                });
            } else {
                setTitle({
                    title: "修正内容はこれでよろしいですか？",
                    message: "修正内容はこれでよろしいですか？",
                    button: "修正",
                    task: "editConfirm"
                });
            }
        } else {
            setMsg("未入力の項目があります。");
        }
    };
    const toggleBack = () => {
        setModal(!modal);
        setNewNotice(!newNotice)
        if (title && title.task === 'addConfirm') {
            setTitle({
                title: "お知らせの追加",
                message: "お知らせの追加",
                button: "確認",
                task: "add"
            });
        } else {
            setTitle({
                title: "お知らせの修正",
                message: "お知らせの修正",
                button: "確認",
                task: "edit"
            });
        }
    }
    const toggleOpenInfo = () => {
        if (msg.includes("失敗")) {
            window.location.reload();
        }
        setOpenInfo(!openInfo);
        setMsg();
    };

    const toggleConfirm = () => {
        setConfirm(!confirm);
        setMsg();
        setNoticeTitle('');
        setTitle({
            title: "",
            message: "",
            button: "",
            task: ""
        });
    }

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        fetchData(signal);

        return () => {
            controller.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSelectedPlants = (values) => {
        setSelectValue(values)
    }

    const fetchData = async (signal) => {
        const data = await getContacts(authToken, groupId, signal);
        console.log('data', data);
        setNotice([
            {
                title: "お知らせ機能追加」のご連絡",
                plants: "全発電所",
                date_time: "2024/04/20 10:00",
                notice: "お客様各位 拝啓、\r\n時下ますますご清栄のこととお喜び申し上げます。 \r\nこの度、本管理画面の「お知らせ通知機能の追加」を実施いたしましたのでご報告させて頂きます。 \r\nこれまで、お電話やメール・手紙にてお客様へご連絡をとらせて頂きましたが、今後はこちらのお知らせ機能でもお客様への情報提供をさせて頂きますので、是非ご活用ください。 \r\n今後とも弊社サービスの更なる充実を推進させて頂きますので何卒よろしくお願いいたします。\r\n株式会社スマートソーラー"
            },
            {
                title: "メンテナンス日程について",
                plants: "KICあきる野",
                date_time: "2024/04/01 10:00",
                notice: "お客様各位 拝啓、\r\n時下ますますご清栄のこととお喜び申し上げます。 \r\nこの度、本管理画面の「お知らせ通知機能の追加」を実施いたしましたのでご報告させて頂きます。 \r\nこれまで、お電話やメール・手紙にてお客様へご連絡をとらせて頂きましたが、今後はこちらのお知らせ機能でもお客様への情報提供をさせて頂きますので、是非ご活用ください。 \r\n今後とも弊社サービスの更なる充実を推進させて頂きますので何卒よろしくお願いいたします。\r\n株式会社スマートソーラー"
            },
            {
                title: "メンテナンス日程について",
                plants: "岩根中学校",
                date_time: "2024/04/20 10:00",
                notice: "お客様各位 拝啓、\r\n時下ますますご清栄のこととお喜び申し上げます。 \r\nこの度、本管理画面の「お知らせ通知機能の追加」を実施いたしましたのでご報告させて頂きます。 \r\nこれまで、お電話やメール・手紙にてお客様へご連絡をとらせて頂きましたが、今後はこちらのお知らせ機能でもお客様への情報提供をさせて頂きますので、是非ご活用ください。 \r\n今後とも弊社サービスの更なる充実を推進させて頂きますので何卒よろしくお願いいたします。\r\n株式会社スマートソーラー"
            },
            {
                title: "【盗難情報】銅線ケーブルの盗難情報",
                plants: "KIC[全発電所]",
                date_time: "2024/03/20 10:00",
                notice: "お客様各位 拝啓、\r\n時下ますますご清栄のこととお喜び申し上げます。 \r\nこの度、本管理画面の「お知らせ通知機能の追加」を実施いたしましたのでご報告させて頂きます。 \r\nこれまで、お電話やメール・手紙にてお客様へご連絡をとらせて頂きましたが、今後はこちらのお知らせ機能でもお客様への情報提供をさせて頂きますので、是非ご活用ください。 \r\n今後とも弊社サービスの更なる充実を推進させて頂きますので何卒よろしくお願いいたします。\r\n株式会社スマートソーラー"
            },
            {
                title: "2025年度の補助金について",
                plants: "木更津SC[全発電所]",
                date_time: "2024/02/20 10:00",
                notice: "お客様各位 拝啓、\r\n時下ますますご清栄のこととお喜び申し上げます。 \r\nこの度、本管理画面の「お知らせ通知機能の追加」を実施いたしましたのでご報告させて頂きます。 \r\nこれまで、お電話やメール・手紙にてお客様へご連絡をとらせて頂きましたが、今後はこちらのお知らせ機能でもお客様への情報提供をさせて頂きますので、是非ご活用ください。 \r\n今後とも弊社サービスの更なる充実を推進させて頂きますので何卒よろしくお願いいたします。\r\n株式会社スマートソーラー"
            },
        ])
        setLoading(false);
    }

    const handleAddNewNotice = () => {
        setNewNotice(!newNotice);
        setTitle({
            title: "お知らせの追加",
            message: "お知らせの追加",
            button: "確認",
            task: "add"
        });
    }

    const handleEdit = (e, index) => {
        const timestamp = notice[index].date_time;
        const spiltTimestamp = timestamp.split(" ");
        const date = format((new Date(spiltTimestamp[0])), 'yyy-MM-dd')
        const time = spiltTimestamp[1];
        setSelectValue(notice[index].plants)
        setTime(time + ":00")
        setDate(date);
        setNoticeTitle(notice[index].title)
        setNoticeDesc(notice[index].notice)
        setTitle({
            title: "お知らせの修正",
            message: "お知らせの修正",
            button: "確認",
            task: "edit"
        });
        setNewNotice(!newNotice)
    }

    const handleDeleteUser = async (e, index) => {
        console.log("Delete Notice")
        setConfirm(!confirm)
        setNoticeTitle(notice[index].title)
        setTitle({
            title: "確認画面",
            message: "以下のお知らせ情報を削除しますか？",
            button: "削除",
            task: "delete"
        });
    }

    const handleDateChangeFrom = (e) => {
        let changedDate;
        if (e === null || e === '') {
            changedDate = ''
        } else {
            changedDate = format((new Date(e)), 'yyy-MM-dd');
        }
        setDate(changedDate);
    };
    const handleInput = async () => {
        if (title.task === "addConfirm") {
            setApiStatus(true);
            setUpdateType('追加');
            setTimeout(() => {
                setApiStatus(false);
                setUpdateType(null);
                setOpenInfo(!openInfo);
                setMsg('追加が成功しました。');
            }, 5000)
            // const data = await addContact(authToken, groupId, noticeTitle, username);
            // if (data === true) {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報を追加しました。");
            //     setOpenInfo(!openInfo);
            //     fetchData();
            // } else {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報の追加に失敗しました。");
            //     setOpenInfo(!openInfo);
            //     // window.location.reload();
            // }
        }
        if (title.task === "editConfirm") {

            setApiStatus(true);
            setUpdateType('修正');
            setTimeout(() => {
                setApiStatus(false);
                setUpdateType(null);
                setOpenInfo(!openInfo);
                setMsg('送信が成功しました。');
            }, 5000)
            // const data = await updateContact(authToken, groupId, noticeTitle, username, id);
            // if (data === true) {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報を更新しました。");
            //     setOpenInfo(!openInfo);
            //     fetchData();
            // } else {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報の更新に失敗しました。");
            //     setOpenInfo(!openInfo);
            //     // window.location.reload();
            // }
        }
        if (title.task === "delete") {
            console.log("Deleted Notice");
            setApiStatus(true);
            setUpdateType('削除');
            setConfirm(!confirm);
            setTimeout(() => {
                setApiStatus(false);
                setUpdateType(null);
                setOpenInfo(!openInfo);
                setMsg('削除が成功しました。');
            }, 5000)
            // const data = await deleteContact(authToken, groupId, noticeTitle, username, id);
            // if (data === true) {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報を削除しました。");
            //     setOpenInfo(!openInfo);
            //     fetchData();
            // } else {
            //     setConfirm(!confirm);
            //     setMsg("ユーザー情報の削除に失敗しました。");
            //     setOpenInfo(!openInfo);
            //     // window.location.reload();
            // }
        }
        setDate(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
        setTime(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm:ss'));
        setNoticeTitle('');
        setNoticeDesc('');
        setSelectValue([]);
        setTitle({ title: "", message: "", button: "", task: "" });
    }
    const handleClose = () => {
        setNewNotice(!newNotice);
        setDate(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'yyyy-MM-dd'));
        setTime(format(utcToZonedTime(new Date(), 'Asia/Tokyo'), 'HH:mm:ss'));
        setNoticeTitle('');
        setNoticeDesc('');
        setSelectValue([]);
        setTitle({ title: "", message: "", button: "", task: "" });
    }

    if (loading) {
        return <Spinner />
    }

    return (
        <Col className="px-5">
            <AddNotice
                title={title.title}
                open={modal}
                btnLeft="キャンセル"
                btnRight={title.button}
                content={
                    <>
                        <div className="form-wrapper-setting justify-content-between disable_edit">
                            <div className="notice-input-wrapper mb-3">
                                <div className='notice-input-field'><label for='name'>投稿日</label>
                                    <DatePicker className='notice_date remote_datepicker'
                                        showIcon
                                        value={date}
                                        portalId="root-portal"
                                        locale={ja}
                                        icon={
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                                <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                                <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                                <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                            </svg>
                                        }
                                    />
                                </div>
                                <div className='notice-input-field'><label for='name'>投稿時間</label>
                                    <Input type="time" bsSize="sm"
                                        className={`remote_time remote__input `}
                                        value={time.split(":").slice(0, -1).join(":")}
                                    />
                                </div>
                            </div>
                            <Dropdown handleSelect={handleSelectedPlants} values={selectValue} disabled={true} />
                            <div className='notice-input-field mb-3 full-field'><label for='name'>タイトル</label>
                                <input type="text" id="noticeTitle" value={noticeTitle} onChange={(e) => { setNoticeTitle(e.target.value); }} />
                            </div>
                            <div className='notice-input-field mb-3 text-area-field'><label for='name'>本文</label>
                                <textarea id="message" name="message" rows="10" cols="50" value={noticeDesc} onChange={(e) => {
                                    setNoticeDesc(e.target.value)
                                }} ></textarea>
                            </div>
                        </div>
                    </>
                }
                handleLeft={toggleBack}
                handleRight={toggleModal}
                handleOpen={() => setModal(!modal)}
            />
            <AddNotice
                title={title.title}
                open={newNotice}
                btnLeft="閉じる"
                btnRight={title.button}
                content={
                    <>
                        <div className="form-wrapper-setting justify-content-between">
                            <div className="notice-input-wrapper mb-3">
                                <div className='notice-input-field'><label for='name'>投稿日</label>
                                    <DatePicker className='notice_date remote_datepicker'
                                        showIcon
                                        value={date}
                                        portalId="root-portal"
                                        icon={
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => setOpenCalendar(!openCalendar)} >
                                                <rect x="3" y="6" width="18" height="15" rx="2" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" />
                                                <path d="M3 10C3 8.11438 3 7.17157 3.58579 6.58579C4.17157 6 5.11438 6 7 6H17C18.8856 6 19.8284 6 20.4142 6.58579C21 7.17157 21 8.11438 21 10H3Z" fill="#233C6B" fill-opacity="0.73" />
                                                <path d="M7 3L7 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                <path d="M17 3L17 6" stroke="#233C6B" stroke-opacity="0.73" stroke-width="2" stroke-linecap="round" />
                                                <rect x="7" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="7" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="13" y="12" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                                <rect x="13" y="16" width="4" height="2" rx="0.5" fill="#233C6B" fill-opacity="0.73" />
                                            </svg>
                                        }
                                        minDate={new Date()}
                                        onChange={(e) => {
                                            handleDateChangeFrom(e);
                                            setOpenCalendar(false)
                                        }}
                                        open={openCalendar}
                                        onInputClick={() => setOpenCalendar(false)}
                                        onClickOutside={() => setOpenCalendar(false)}
                                        popperPlacement="bottom"
                                    />
                                </div>
                                <div className='notice-input-field'><label for='name'>投稿時間</label>
                                    <input type="time" bsSize="sm" className={`ml-2 remoteEdit_time ${timeFocus && 'empty'}`}
                                        onChange={(e) => {
                                            setTime(e.target.value + ':00');
                                            if (e.target.value !== '') {
                                                setTimeFocus(false);
                                            } else {
                                                setTimeFocus(true);
                                            }
                                        }}
                                        value={time.split(":").slice(0, -1).join(":")}
                                    />
                                </div>
                            </div>
                            <Dropdown handleSelect={handleSelectedPlants} values={selectValue} disabled={false} />
                            <div className='notice-input-field mb-3 full-field'><label for='name'>タイトル</label>
                                <input type="text" id="noticeTitle" value={noticeTitle} onChange={(e) => { setNoticeTitle(e.target.value); }} />
                            </div>
                            <div className='notice-input-field mb-3 text-area-field'><label for='name'>本文</label><textarea id="message" name="message" rows="10" cols="50" value={noticeDesc} onChange={(e) => {
                                setNoticeDesc(e.target.value)
                            }} ></textarea>
                            </div>
                        </div>

                        <p className="text-danger mt-3 modalContent">{msg}</p>
                    </>
                }
                handleLeft={handleClose}
                handleRight={toggleNewNotice}
                handleOpen={() => setNewNotice(!newNotice)}
            />
            <InfoModal
                open={openInfo}
                button="OK"
                content={msg}
                handleButton={toggleOpenInfo}
            />

            <ConfirmationModal title={title.title}
                open={confirm}
                btnLeft="キャンセル"
                btnRight={title.button}
                content={
                    <>
                        <p>{title.message}</p>
                        <div className="pl-2 info-box">
                            <p>
                                件名：{noticeTitle}
                            </p>

                        </div>
                    </>
                }
                handleLeft={toggleConfirm}
                handleRight={handleInput}
                // handleOpen={toggleNewUser}
                status={false}
            />

            {apiStatus && <LoadingModal
                open={apiStatus}
                content={
                    <>
                        <span className="remoteModal_status">
                            {updateType}中です。
                        </span>
                        <span className="remoteModal_status">しばらくお待ちください。</span>
                    </>
                }
            />}

            <Row className="text_graph justify-content-center mt-2">
                お知らせ設定
            </Row>
            <Row className="settingsTable">
                <div className="setting mx-2 pb-4 pt-1">
                    <span>各発電所へ向けたお知らせの追加・変更・削除を行えます。</span><br />
                    {/* <span>新規ユーザーの登録、変更、削除が行えます</span> */}
                </div>
            </Row>
            <Row>
                <div className="notice-table-container col">
                    <Table className="table_setting table-responsive mx-2 notice-table">
                        <thead>

                            <th className="tableheader1">番号</th>
                            <th>件名</th>
                            <th>宛先</th>
                            <th>投稿日時</th>
                            <th className="tableheader2">
                                <div className="setting_header">
                                    <div className="setting_header1">追加</div>
                                    <div className="setting-header2">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" onClick={() => handleAddNewNotice()} style={{ cursor: "pointer" }}>
                                            <rect width="32" height="32" fill="#233C6B" />
                                            <line x1="6" y1="16" x2="26" y2="16" stroke="white" stroke-width="2" />
                                            <line x1="16" y1="26" x2="16" y2="6" stroke="white" stroke-width="2" />
                                        </svg>
                                    </div>
                                </div>
                            </th>

                        </thead>
                        <tbody>
                            {notice && notice.map((value, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}.</td>
                                        <td>{value.title}</td>
                                        <td>{value.plants}</td>
                                        <td>
                                            <div className="email-icons">
                                                <div className="email-box">
                                                    {value.date_time}
                                                </div>

                                                <div className="action-icons">
                                                    <svg width="15" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleEdit(e, index) }} className="desktopIcons" style={{ cursor: "pointer" }}>
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M14.2038 7.79601L15.9998 6C16.545 5.45475 16.8176 5.18213 16.9634 4.88803C17.2407 4.32848 17.2407 3.67153 16.9634 3.11197C16.8176 2.81788 16.545 2.54525 15.9998 2C15.4545 1.45475 15.1819 1.18213 14.8878 1.03639C14.3282 0.75911 13.6713 0.75911 13.1117 1.03639C12.8176 1.18213 12.545 1.45475 11.9998 2L10.1811 3.81866C11.145 5.46926 12.5311 6.84482 14.2038 7.79601ZM8.72666 5.27312L1.85615 12.1436C1.43109 12.5687 1.21856 12.7812 1.07883 13.0423C0.939091 13.3034 0.880146 13.5981 0.762256 14.1876L0.14686 17.2646C0.0803376 17.5972 0.0470765 17.7635 0.141684 17.8581C0.236293 17.9527 0.402598 17.9194 0.735208 17.8529L3.81219 17.2375C4.40164 17.1196 4.69637 17.0607 4.95746 16.9209C5.21856 16.7812 5.43109 16.5687 5.85615 16.1436L12.7456 9.25422C11.1239 8.23857 9.7522 6.87628 8.72666 5.27312Z" fill="#233C6B" />
                                                    </svg>
                                                    <svg width="15" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleDeleteUser(e, index) }} className="trash-icon desktopIcons" style={{ cursor: "pointer" }}>
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H1C0.447715 6 0 5.55228 0 5Z" fill="#FF0000" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 6.44772 0 7 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H7C6.44772 2 6 1.55228 6 1Z" fill="#FF0000" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3.55228 4 4 4.44772 4 5V24H20V5C20 4.44772 20.4477 4 21 4C21.5523 4 22 4.44772 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H4C3.46957 26 2.96086 25.7893 2.58579 25.4142C2.21071 25.0391 2 24.5304 2 24V5C2 4.44772 2.44772 4 3 4Z" fill="#FF0000" />
                                                    </svg>

                                                </div>

                                            </div>


                                        </td>
                                        <td className="mobileIcons">
                                            <svg width="20" height="30" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleEdit(e, index) }} style={{ cursor: "pointer" }}>
                                                <path fillRule="evenodd" clipRule="evenodd" d="M14.2038 7.79601L15.9998 6C16.545 5.45475 16.8176 5.18213 16.9634 4.88803C17.2407 4.32848 17.2407 3.67153 16.9634 3.11197C16.8176 2.81788 16.545 2.54525 15.9998 2C15.4545 1.45475 15.1819 1.18213 14.8878 1.03639C14.3282 0.75911 13.6713 0.75911 13.1117 1.03639C12.8176 1.18213 12.545 1.45475 11.9998 2L10.1811 3.81866C11.145 5.46926 12.5311 6.84482 14.2038 7.79601ZM8.72666 5.27312L1.85615 12.1436C1.43109 12.5687 1.21856 12.7812 1.07883 13.0423C0.939091 13.3034 0.880146 13.5981 0.762256 14.1876L0.14686 17.2646C0.0803376 17.5972 0.0470765 17.7635 0.141684 17.8581C0.236293 17.9527 0.402598 17.9194 0.735208 17.8529L3.81219 17.2375C4.40164 17.1196 4.69637 17.0607 4.95746 16.9209C5.21856 16.7812 5.43109 16.5687 5.85615 16.1436L12.7456 9.25422C11.1239 8.23857 9.7522 6.87628 8.72666 5.27312Z" fill="#233C6B" />
                                            </svg>
                                            <svg width="22" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleDeleteUser(e, index) }} className="trash-icon" style={{ cursor: "pointer" }}>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H1C0.447715 6 0 5.55228 0 5Z" fill="#FF0000" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 6.44772 0 7 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H7C6.44772 2 6 1.55228 6 1Z" fill="#FF0000" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3.55228 4 4 4.44772 4 5V24H20V5C20 4.44772 20.4477 4 21 4C21.5523 4 22 4.44772 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H4C3.46957 26 2.96086 25.7893 2.58579 25.4142C2.21071 25.0391 2 24.5304 2 24V5C2 4.44772 2.44772 4 3 4Z" fill="#FF0000" />
                                            </svg>

                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </Row>
        </Col >
    )
}

export default NoticeSetting;